export function createMouseDragHandler(callBackMouseDown: any, callBackMouseMove: any, callBackMouseUp: any) {
  // to be set to onPointerDownCapture
  return (e: any) => {
    e.preventDefault();
    const elemOffset = e.target.getBoundingClientRect();
    const target = e.target;
    const pointerId = e.pointerId;
    target.setPointerCapture(pointerId);
    const startX = e.clientX - elemOffset.left;
    const startY = e.clientY - elemOffset.top;
    let lastX = startX;
    let lastY = startY;
    if (callBackMouseDown) callBackMouseDown(e, startX, startY);
    const handleDocumentMouseUp = (eUp: any) => {
      target.releasePointerCapture(pointerId);
      document.removeEventListener('pointerup', handleDocumentMouseUp);
      document.removeEventListener('pointermove', handleDocumentMouseMove);
      if (callBackMouseUp) callBackMouseUp(eUp);
    };
    const handleDocumentMouseMove = (eMove: any) => {
      eMove.preventDefault();
      const posX = eMove.clientX - elemOffset.left;
      const posY = eMove.clientY - elemOffset.top;
      if (callBackMouseMove) callBackMouseMove(e, posX, posY, posX - lastX, posY - lastY);
      lastX = posX;
      lastY = posY;
    };
    document.addEventListener('pointerup', handleDocumentMouseUp);
    document.addEventListener('pointermove', handleDocumentMouseMove);
  };
}

export function getPixelRatio(context: any, isHighRes: boolean) {
  if (isHighRes) return 6;
  if (!context) return 1;
  const backingStore =
    context.backingStorePixelRatio ||
    context.webkitBackingStorePixelRatio ||
    context.mozBackingStorePixelRatio ||
    context.msBackingStorePixelRatio ||
    context.oBackingStorePixelRatio ||
    context.backingStorePixelRatio ||
    1;
  return (window.devicePixelRatio || 1) / backingStore;
}
